import { render } from "./ServiceStationTxlCard.vue?vue&type=template&id=5b2d2d74&scoped=true&ts=true"
import script from "./serviceStationTxlCardHelper.ts?vue&type=script&lang=ts"
export * from "./serviceStationTxlCardHelper.ts?vue&type=script&lang=ts"

import "./ServiceStationTxlCard.vue?vue&type=style&index=0&id=5b2d2d74&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2d2d74"]])

export default __exports__